import { pull } from 'gleam-shared/helpers/nodash'

const SIGN = 'isTinyEmitter'

export function isEmitter(value) {
  return !!value?.[SIGN]
}

export default function Emitter() {
  const callbacks = []

  return { on, off, emit, clear, [SIGN]: true }

  function on(callback) {
    callbacks.push(callback)
  }

  function off(callback) {
    pull(callbacks, callback)
  }

  function emit(value) {
    const copy = callbacks.concat()

    for (const callback of copy) {
      callback(value)
    }
  }

  function clear() {
    callbacks.length = 0
  }
}
